import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthenticationService } from './auth/authentication.service';
import { NpwpResponse } from '../_model/global/npwp.model';
import { ResponseReqToken, findByNrk } from '../_model/global/referensi.model';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { DownloadObjectRequest, previewReq } from '../_model/global/upload.model';
import * as CryptoJS from 'crypto-js';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class GlobalService {

    constructor(private _http: HttpClient, private _auth: AuthenticationService, private _toast: ToastrService,
    ) {
    }

    public getTahunAnggaran() {
        return this._http.get(`${environment.uriAuth}/api/public/tahun-anggaran`, { observe: 'response' });
    }
    public getBulanLogin(tahunAnggaran: string) {
        return this._http.get<any>(`${environment.uriAuth}/api/public/bulan/find-by-tahun/${tahunAnggaran}`, { observe: 'response' });
    }
    public listSumberDana() {
        return this._http.get(`${environment.uriAuth}/api/public/sumber-dana`, { observe: 'response' });
    }
    public updateBulanLogin(tahunAnggaran: string, bulan: string) {
        return this._http.put(`${environment.uriAuth}/api/public/bulan/update/${tahunAnggaran}/${bulan}`, { observe: 'response' });
    }

    public getBulanLoginUser(nrk: string) {
        return this._http.get<any>(`${environment.uriAuth}/api/public/bulan-login/find-by-nrk/${nrk}`, { observe: 'response' });
    }
    public updateBulanResetPassword(nrk: string, bulan: string) {
        return this._http.put(`${environment.uriAuth}/api/public/bulan-login/update/${nrk}/${bulan}`, { observe: 'response' });
    }


    public listJenisPeriode() {
        return this._http.get(`${environment.uriAuth}/api/public/jenis-periode`, { observe: 'response' });
    }

    public listPeriodeByJenis(kodeJenisPeriode: string) {
        return this._http.get<any[]>(`${environment.uriAuth}/api/public/periode/${kodeJenisPeriode}`, { observe: 'response' });
    }

    public listBulan() {
        return this._http.get(`${environment.uriAuth}/api/public/bulan`, { observe: 'response' });
    }

    public listBulanByPeriode(kodeJenisPeriode: string, kodePeriode: string) {
        return this._http.get(`${environment.uriAuth}/api/public/bulan-by-periode/${kodeJenisPeriode}/${kodePeriode}`, { observe: 'response' });
    }
    // Find NPWP BY NO NPWP
    public findNpwpByNoNpwp(nomorNpwp: any) {
        const encryptedNpwp = this.encrypt(nomorNpwp);
        const encodedNpwp = encodeURIComponent(encryptedNpwp);
        let params = new HttpParams();
        params = params.append('nomorNpwp', encodedNpwp);
        return this._http.get<any>(`${environment.uriIntegration}/api/npwp/byNomorNpwp`, {
            observe: 'response',
            params: params,
        }).pipe(
            map(response => {
                const decryptedBody = this.decrypt(response.body?.data);
                const parsedBody: NpwpResponse = JSON.parse(decryptedBody);
                console.log(parsedBody);
                return { ...response, body: parsedBody };
            }), catchError(error => {
                console.log("ininini");
                return throwError(error);

            })
        );
    }
    // CHECK REKENING
    public checkRekening(norek: string, kodeBank: string) {
        let params = new HttpParams();
        params = params.append('norek', norek);
        params = params.append('kodebank', kodeBank);
        return this._http.post(`${environment.uriIntegration}/api/bank-dki/inquiryCheckRek`, null, {
            observe: 'response',
            params: params,
        });
    }
    numberOnly(event): boolean {
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            this._toast.warning('Tidak Bisa Input Selain Angka', 'Hanya Angka');
            return false;
        }
        return true;
    }

    // REQUEST NRK
    public findPegawaiByNrk(nrk: string) {
        console.log(typeof nrk);
        console.log(nrk === null);
        console.log(nrk === 'null');
        let params = new HttpParams();
        params = params.append('nrk', nrk);
        return this._http.get<findByNrk>(`${environment.uriIntegration}/api/simpeg/getPegawai/byNrk`, {
            observe: 'response',
            params: params,
        });
    }

    // REQUEST TOKEN BANK DKI
    public requestToken(nrkPenggunaAnggaran: string) {
        console.log(typeof nrkPenggunaAnggaran);
        console.log(nrkPenggunaAnggaran === null);
        console.log(nrkPenggunaAnggaran === 'null');
        let params = new HttpParams();
        params = params.append('userid', nrkPenggunaAnggaran);
        return this._http.post<ResponseReqToken>(`${environment.uriIntegration}/api/bank-dki/createToken`, null, {
            observe: 'response',
            params: params,
        });
    }

    public searchMaxDateFromMonth(month, year) {
        // month | string | ex: Januari = '01'
        // year | string | ex: '2021'
        const d = new Date(+year, (+month - 1) + 1, 0); // month + 1 -> Karena new Date Javascript Januari start = 0
        return moment(d).format('YYYY-MM-DD');
    }



    // UploadImage
    public upload(file: File, folder: any): Observable<HttpEvent<any>> {
        const formData: FormData = new FormData();

        formData.append('file', file);
        formData.append('folder', folder)

        const req = new HttpRequest('POST', `${environment.uriUploader}/api/v1/minio/upload`, formData, {
            reportProgress: true,
            responseType: 'json',
        });

        return this._http.request(req);
    }
    // Preview Minio
    public previewInvoice(preview: previewReq) {
        return this._http.post<any>(`${environment.uriUploader}/api/v1/minio/preview`, preview, { observe: "response" })
    }

    public downloadFilePdf(request: DownloadObjectRequest): Observable<Blob> {
        // Make the POST request to the API
        return this._http.post(
            `${environment.uriUploader}/api/v1/minio/download-pdf`,  // Make sure this URL is correct
            request,  // Send the request body as the DownloadObjectRequest
            {
                responseType: 'blob'  // Expect a Blob (PDF file) in response
            }
        );
    }

     public downloadPreviewFilePdf(request: DownloadObjectRequest): Observable<Blob> {
        // Make the POST request to the API
        return this._http.post(
            `${environment.uriUploader}/api/v1/minio/preview-pdf`,  // Make sure this URL is correct
            request,  // Send the request body as the DownloadObjectRequest
            {
                responseType: 'blob'  // Expect a Blob (PDF file) in response
            }
        );
    }

    public downloadPreviewFile(request: DownloadObjectRequest): Observable<Blob> {
        // Make the POST request to the API
        return this._http.post(
            `${environment.uriUploader}/api/v1/minio/preview-file-multiple-format`,  // Make sure this URL is correct
            request,  // Send the request body as the DownloadObjectRequest
            {
                headers: new HttpHeaders().set('Accept', 'application/json'),  // Optional: add headers if needed, e.g. for authentication
                responseType: 'blob'  // Expect a Blob (PDF file) in response
            }
        );
    }

    public download(request: DownloadObjectRequest): Observable<Blob> {
        return this._http.post(
            `${environment.uriUploader}/api/v1/minio/download`,
            request,
            {
                responseType: 'blob'
            }
        );
    }

    


    public findOpdById(id: number) {
        return this._http.get<any>(`${environment.uriAuth}/api/public/opd/find-by-id/${id}`, { observe: 'response' });
    }

    private encrypt(data: string): string {
        const encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(environment.encryptionKey), {
            iv: CryptoJS.enc.Utf8.parse(environment.encryptionKey),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    }

    public decrypt(encryptedData: string): string {
        const key = CryptoJS.enc.Utf8.parse(environment.encryptionKey);
        const iv = CryptoJS.enc.Utf8.parse(environment.encryptionKey);
        try {
            const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });
            const descryptedData = decrypted.toString(CryptoJS.enc.Utf8)
            return descryptedData;
        } catch (error) {
            console.error("Error during decryption:", error);
            throw new Error("Decryption failed");
        }
    }
}
